(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hikmati-founder-story"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('hikmati-story-journey')) {
  customElements.define('hikmati-story-journey', class extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('[data-story-reveal]')];
      this.chapters = [...this.querySelectorAll('.hk-story__chapter')];
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.route = this.querySelector('[data-journey-route]');
      this.path = this.querySelector('[data-route-progress]');
      this.printLayer = this.querySelector('[data-route-prints]');
      this.routeBox = this.querySelector('.hk-story__path');
      this.steps = [];
      this.maxDistance = 0;
      this.staticMode = this.dataset.motion !== 'true' || this.motion.matches || window.Shopify?.designMode;
      this.showAll = () => {
        this.items.forEach(item => { item.dataset.state = 'visible'; item.classList.add('is-read'); });
        if (this.observer) this.observer.disconnect();
      };
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.updateRoute(); });
      };
      this.onPreference = event => {
        this.staticMode = this.dataset.motion !== 'true' || event.matches || window.Shopify?.designMode;
        if (this.staticMode) this.showAll();
        this.schedule();
      };
      this.motion.addEventListener('change', this.onPreference);
      try {
        if (this.staticMode || !('IntersectionObserver' in window)) this.showAll();
        else {
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;
              entry.target.dataset.state = 'visible';
              entry.target.classList.add('is-read');
              this.observer.unobserve(entry.target);
            });
          }, { threshold: 0.08, rootMargin: '0px 0px -24px 0px' });
          this.items.forEach(item => {
            if (item.getBoundingClientRect().top < window.innerHeight - 24) { item.dataset.state = 'visible'; item.classList.add('is-read'); }
            else { item.dataset.state = 'pending'; this.observer.observe(item); }
          });
        }
        this.buildRoute();
        this.onResize = () => { this.buildRoute(); this.schedule(); };
        if (this.route && 'ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.onResize);
          this.resizeObserver.observe(this.routeBox);
        }
        if (this.route) {
          window.addEventListener('scroll', this.schedule, { passive: true });
          window.addEventListener('resize', this.onResize, { passive: true });
          this.schedule();
        }
      } catch { this.showAll(); if (this.route) this.route.style.display = 'none'; }
    }
    buildRoute() {
      if (!this.route || !this.path) return;
      const h = Math.max(this.routeBox.offsetHeight, 1);
      const w = Math.max(this.route.getBoundingClientRect().width, 20);
      const sizeKey = `${Math.round(w)}:${h}`;
      if (this.sizeKey === sizeKey) return;
      this.sizeKey = sizeKey;
      this.maxDistance = 0;
      const center = w / 2;
      const swing = w * .24;
      const count = Math.max(2, Math.ceil(h / 250));
      const span = h / count;
      let d = `M ${center} 0`;
      for (let i = 0; i < count; i++) {
        const y = i * span;
        const sign = i % 2 ? -1 : 1;
        d += ` C ${center - swing * sign} ${y + span * .3}, ${center + swing * sign} ${y + span * .7}, ${center} ${y + span}`;
      }
      this.route.setAttribute('viewBox', `0 0 ${w} ${h}`);
      this.route.querySelector('.hk-story__route-base').setAttribute('d', d);
      this.path.setAttribute('d', d);
      this.routeLength = this.path.getTotalLength();
      this.printLayer.replaceChildren();
      this.steps = [];
      const gap = Math.max(w < 40 ? 35 : 39, this.routeLength / 100);
      const ns = 'http://www.w3.org/2000/svg';
      for (let distance = 20, i = 0; distance < this.routeLength - 12; distance += gap, i++) {
        const p = this.path.getPointAtLength(distance);
        const q = this.path.getPointAtLength(Math.min(distance + 2, this.routeLength));
        const angle = Math.atan2(q.y - p.y, q.x - p.x) * 180 / Math.PI + 90;
        const group = document.createElementNS(ns, 'g');
        const scale = w < 40 ? .48 : .65;
        group.setAttribute('class', 'hk-story__foot');
        group.setAttribute('transform', `translate(${p.x} ${p.y}) rotate(${angle}) translate(${i % 2 ? 5 : -5} 0) scale(${i % 2 ? -scale : scale} ${scale})`);
        const sole = document.createElementNS(ns, 'path');
        sole.setAttribute('d', 'M0 8C-5 7-5 0-2-4C0-7 4-6 5-2C6 2 4 6 0 8Z');
        group.append(sole);
        [[-3,-9,2.7],[1,-11,2.1],[4.4,-10.2,1.65],[6.5,-8,1.3],[7.5,-5.3,1]].forEach(([cx,cy,r]) => {
          const toe = document.createElementNS(ns, 'circle');
          toe.setAttribute('cx', String(cx)); toe.setAttribute('cy', String(cy)); toe.setAttribute('r', String(r)); group.append(toe);
        });
        this.printLayer.append(group);
        this.steps.push({ node: group, distance, shown: false });
      }
    }
    updateRoute() {
      if (!this.path || !this.routeLength) return;
      const box = this.routeBox.getBoundingClientRect();
      const ratio = this.staticMode ? 1 : Math.max(0, Math.min(1, (window.innerHeight * .64 - box.top) / Math.max(box.height, 1)));
      this.maxDistance = Math.max(this.maxDistance, ratio * this.routeLength);
      this.path.style.strokeDasharray = `${this.maxDistance} ${this.routeLength}`;
      this.steps.forEach(step => {
        if (!step.shown && step.distance <= this.maxDistance) { step.shown = true; step.node.classList.add('is-stepped'); }
      });
    }
    disconnectedCallback() {
      this.observer?.disconnect(); this.resizeObserver?.disconnect();
      this.motion?.removeEventListener('change', this.onPreference);
      window.removeEventListener('scroll', this.schedule); window.removeEventListener('resize', this.onResize);
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
